"use client";

import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./wallet.module.css";
import { faPlus, faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { useSidebarContext } from "../Context";
import { useAppContext } from "../../../../../AppContext";

import * as apiClient from "../../../../../common/apiClient";
import * as apiMethod from "../../../../../common/apiMethod";
import * as appModule from "../../../../../common/appModule";
import AddPayment from "./AddPayment";

export default function Wallet() {
  const { isSidebarCollapsed } = useSidebarContext();
  const { state, dispatch } = useAppContext();

  const [isAddPayment, setIsAddPayment] = useState(false);
  const [isLoadingWallet, setLoadingWallet] = useState(false);
  const [isWalletMenuOpen, setIsWalletMenuOpen] = useState(false);
  const [isWalletEnabled, setIsWalletEnabled] = useState(false);
  const [balance, setBalance] = useState(0);

  const walletRef = useRef(null);

  useEffect(() => {
    loadConsignors();
  }, []);
  useEffect(() => {
    setBalance(state.walletBalance);
  }, [state.walletBalance]);

  const loadWidgets = async (customfilter) => {
    let formBody = {};

    await apiClient
      .post(
        `${apiClient.baseUrl}${appModule.tmsModule}${apiMethod.tmsMethod.booking.getZohoCustomerBalance}`,
        formBody
      )
      .then((response) => {
        if (response.IsSuccess) {
          var currentAmt =
            parseInt(response.ResultSet.unused_credits) +
            parseInt(response.ResultSet.unused_credits_receivable_amount);

          dispatch({ type: "WALLET_BALANCE", payload: currentAmt });
        }
      })
      .catch((err) => {});
    // return result;
  };
  const loadConsignors = async () => {
    let excludeRecords = [];
    let result = [];
    let formBody = {
      dataSize: 10,
      excludeRecords: excludeRecords,
      displayFields: [
        { field: "ConsignorName" },
        { field: "ConsignorCode" },
        { field: "IsPrepaidConsignor" },
      ],
      filters: [
        { field: "ConsignorName", value: "" },
        { field: "ConsignorCode", value: "" },
      ],
      sortFields: [{ field: "ConsignorName", sortDirection: "asc" }],
      defaultfilters: [{ field: "isActive", value: "1" }],
    };
    setLoadingWallet(true);
    await apiClient
      .post(
        `${apiClient.baseUrl}${appModule.masterModule}${apiMethod.getUserConsignors}`,
        formBody
      )
      .then((response) => {
        if (response.IsSuccess) {
          result = response.ResultSet;

          if (result && result.length == 1) {
            setIsWalletEnabled(result[0].IsPrepaidConsignor);
            if (result[0].IsPrepaidConsignor) {
              loadWidgets();
            }
          }
        }
        setLoadingWallet(false);
      })
      .catch((err) => {
        result = [];
        setLoadingWallet(false);
      });
    return result;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (walletRef.current && !walletRef.current.contains(event.target)) {
        setIsWalletMenuOpen(false);
      }
    };

    if (isWalletMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isWalletMenuOpen]);

  const handleWalletClick = () => {
    if (!isSidebarCollapsed) return;
    setIsWalletMenuOpen((prev) => !prev);
  };

  const handleClosePopup = () => {
    setIsAddPayment(false);
    loadWidgets(null);
    window.location.reload(false);
  };

  return isWalletEnabled ? (
    <div
      ref={walletRef}
      className={`${styles.wallet_container} ${
        isSidebarCollapsed ? styles.collapsed : ""
      }`}
      onClick={handleWalletClick}
    >
      {isSidebarCollapsed ? (
        <WalletCollapsed
          isWalletHover={isWalletMenuOpen}
          balance={balance}
          setIsAddPayment={setIsAddPayment}
        />
      ) : (
        <>
          <div className={styles.wallet_info}>
            <span className={styles.wallet_heading}>Wallet</span>
            <span className={styles.wallet_balance}>
              <span className={styles.ruppe_symbol}>₹</span> {balance ?? 0.0}
            </span>
          </div>
          <button
            className={styles.add_money_button}
            onClick={() => setIsAddPayment(true)}
          >
            <FontAwesomeIcon className={styles.plus_icon} icon={faPlus} />
            Add money
          </button>
        </>
      )}
      {isAddPayment === true && (
        <AddPayment
          isOpen={isAddPayment}
          handleClosePopup={handleClosePopup}
          popupTtile={"Add Payment"}
          widgetType={""}
          data={[]}
        />
      )}
    </div>
  ) : (
    <></>
  );
}

function WalletCollapsed({ isWalletHover, balance, setIsAddPayment }) {
  return (
    <>
      <FontAwesomeIcon
        icon={faCreditCard}
        className={styles.wallet_icon_collapsed}
      />
      <span className={styles.wallet_ballance_collapsed}>
        {balance ? `₹ ${balance}` : "₹ 0.0"}
      </span>
      {isWalletHover && <WalletHover setIsAddPayment={setIsAddPayment} />}
    </>
  );
}

function WalletHover({ balance, setIsAddPayment }) {
  return (
    <div className={`${styles.wallet_container} ${styles.hover}`}>
      <FontAwesomeIcon icon={faCreditCard} className={styles.wallet_icon} />
      <span className={styles.wallet_ballance}>
        {balance ? `₹${balance}` : "₹ 0.0"}
      </span>
      <button
        className={styles.add_money_button}
        onClick={() => setIsAddPayment(true)}
      >
        <FontAwesomeIcon className={styles.plus_icon} icon={faPlus} />
        Add money
      </button>
    </div>
  );
}
